import { render, staticRenderFns } from "./ClientsFormPage.vue?vue&type=template&id=288ebb4d&scoped=true&"
import script from "./ClientsFormPage.vue?vue&type=script&lang=js&"
export * from "./ClientsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientsFormPage.vue?vue&type=style&index=0&id=288ebb4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288ebb4d",
  null
  
)

export default component.exports